import useMemoizedFn from "ahooks/es/useMemoizedFn";
import { atom, useAtom } from "jotai";

export type UseAdminFormResult = {
  isOpen: boolean;
  openDialog(): void;
  closeDialog(): void;
};

const isOpenAtom = atom<boolean>(false);

export function useAddAdminForm(): UseAdminFormResult {
  const [isOpen, setIsOpen] = useAtom(isOpenAtom);

  const openDialog = useMemoizedFn(() => {
    setIsOpen(true);
  });

  const closeDialog = useMemoizedFn(() => {
    setIsOpen(false);
  });

  return {
    isOpen,
    openDialog,
    closeDialog,
  };
}
